import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useLocalization } from 'contexts/LocalizationContext.jsx';
import { useTooltipContext } from 'contexts/TooltipContext.jsx';
import constants from 'constants/tooltips.js';
import StepTooltip from 'components-v3/StepTooltip/index.jsx';
import { ON_DEMAND_PRODUCT } from 'constants/products.js';
import usePermissions from 'hooks/usePermissions.jsx';
import useProductDataOutsideRoutes from 'hooks/useProductDataOutsideRoutes.js';

const ProductSwitcherTooltip = ({
  openProductSwitcher,
  hideTooltip,
  isProductHeaderExpanded,
  children,
}) => {
  const { t } = useLocalization();
  const { pathname } = useLocation();
  const { hasOrgSpecificProductPermission } = usePermissions();
  const { selectedProduct, orgId } = useProductDataOutsideRoutes();

  const { isTooltipVisible } = useTooltipContext();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasOnDemandProductAccess = hasOrgSpecificProductPermission(orgId, ON_DEMAND_PRODUCT);
    const canShowTooltip = (selectedProduct !== ON_DEMAND_PRODUCT) && hasOnDemandProductAccess;
    setIsVisible(!isProductHeaderExpanded && canShowTooltip
      && isTooltipVisible(constants.ONE_DEMAND) && !hideTooltip);
  }, [pathname, isTooltipVisible, isProductHeaderExpanded, hideTooltip, selectedProduct]);

  const openNavigation = () => {
    openProductSwitcher();
  };

  return (
    <StepTooltip
      title={t('genericLabels.productSwitcherTooltipTitle')}
      description={t('genericLabels.productSwitcherTooltipDescription')}
      tooltipKey={constants.ONE_DEMAND}
      step={1}
      maxSteps={2}
      variant="orange"
      onNext={openNavigation}
      isShown={isVisible}
      minWidth="300px"
      style={{
        zIndex: 4,
      }}
      tooltipPosition="bottom"
    >
      {children}
    </StepTooltip>
  );
};

export default ProductSwitcherTooltip;
